const initTooltips = () => {
  const jq = window.jQuery || window.$
  if (!jq || typeof jq.fn.tooltip !== 'function') return

  jq('[data-toggle="tooltip"]').each(function () {
    const el = jq(this)
    if (el.data('bs.tooltip')) return
    el.tooltip({
      trigger: 'hover focus',
      container: 'body',
      boundary: 'viewport'
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTooltips)
} else {
  initTooltips()
}

window.addEventListener('load', initTooltips)
